// Large media (hero video) lives on the Lovable asset CDN and is referenced by
// a root-relative URL such as `/__l5e/assets-v1/<id>/hero-1280.mp4`.
//
// That path is only served by Lovable's preview / published hosting. On a local
// dev server (CRA on localhost:3000) the same path falls through to the SPA
// index.html, so the <video> receives text/html and silently renders nothing.
//
// Resolving the path against the project's public host keeps local development
// identical to production without committing 20 MB binaries to the repo.

// Stable, publicly reachable asset origin (CORS: *). The `project--` host is
// immutable and does not require a Lovable session, so it also works from
// Netlify, a custom domain or localhost.
const CDN_ORIGIN = "https://project--331f6b60-220f-4e87-9b0d-67b7807f24cb.lovable.app";

const isLovableHost = (hostname) =>
  hostname.endsWith(".lovable.app") || hostname.endsWith(".lovableproject.com");

export function assetUrl(asset) {
  const url = typeof asset === "string" ? asset : asset && asset.url;

  if (!url) return "";

  // Already absolute – nothing to do.
  if (/^https?:\/\//i.test(url)) return url;

  if (typeof window === "undefined") return `${CDN_ORIGIN}${url}`;

  const { hostname } = window.location;

  // Served by Lovable (preview, published or a custom domain proxying it):
  // the relative path resolves correctly on its own.
  if (isLovableHost(hostname)) return url;

  // Any other host (Netlify, custom domain, localhost): the SPA catch-all would
  // answer `/__l5e/...` with index.html, so point at the CDN explicitly.
  return `${CDN_ORIGIN}${url}`;
}

export default assetUrl;
